import { useParams, useNavigate } from "react-router-dom";
import { useGetOneBlogQuery, useDeleteBlogMutation } from "./blogApiSlice";
import { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Dodaj stilove za ReactQuill

const BlogDetailsAdmin = () => {
  const { id } = useParams();
  // const { isKlijent, isAdmin } = useAuth();
  // const navigate = useNavigate();

  // const vratiLista = navigate("/blogsAdmin");

  // const [postImage, setPostImage] = useState({ myFile: "" });
  const [blog, setblog] = useState();
  // console.log("id", id);

  const {
    isSuccess: isSuccessGetBlog,
    isError: isErrorGetBlog,
    error: errorBlogError,
    data: getBlogData,
  } = useGetOneBlogQuery(id);

  useEffect(() => {
    if (isSuccessGetBlog) {
      // alert(dataGetBlog.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
      setblog(getBlogData);
    }

    if (isErrorGetBlog) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorBlogError?.data?.message);
    }
  }, [isSuccessGetBlog, isErrorGetBlog, errorBlogError, getBlogData]);

  // useEffect(() => {
  //   console.log("blog => ", blog);
  // }, [blog]);

  function formatDateToReadable(dateStr) {
    const date = new Date(dateStr);

    const readableDate = date.toLocaleDateString("sr-RS", {
      year: "numeric", // godina
      month: "numeric", // mesec
      day: "numeric", // dan
    });

    return readableDate;
  }

  return (
    <>
      <div className="blog-details max-w-6xl mx-auto p-8 bg-green-50 rounded-xl shadow-2xl">
        {blog && (
          <article className="space-y-8">
            {/* Title */}
            <h2 className="text-3xl md:text-5xl font-extrabold text-green-800">
              {blog.title}
            </h2>

            {/* Image */}
            <img
              src={blog.slika}
              alt="Neka slika ovde"
              className="w-full h-96 object-cover rounded-xl shadow-xl"
            />

            {/* Information about tags, author, and date */}
            <div className="flex flex-col md:flex-row items-start md:items-center text-base text-green-600 space-y-4 md:space-y-0 md:space-x-8">
              {/* Tags */}
              <p className="flex items-center space-x-4">
                <span className="mr-3 text-xl">🥦</span>
                <span className="text-lg font-semibold text-green-800">
                  Tagovi:
                </span>
                <div className="flex flex-wrap gap-2">
                  {Array.isArray(blog.tags) ? (
                    blog.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300"
                      >
                        {tag}
                      </span>
                    ))
                  ) : (
                    <span className="text-red-600">
                      Tagovi nisu u pravilnom formatu.
                    </span>
                  )}
                </div>
              </p>

              {/* Author */}
              <p className="flex items-center space-x-4">
                <span className="mr-3 text-xl">👨‍🍳</span>
                <span className="text-lg font-semibold text-green-800">
                  Autor:
                </span>
                <span className="text-green-700">{blog.author}</span>
              </p>

              {/* Date */}
              <p className="flex items-center space-x-4">
                <span className="mr-3 text-xl">⏰</span>
                <span className="text-lg font-semibold text-green-800">
                  Datum:
                </span>
                <span className="text-green-700">
                  {formatDateToReadable(blog.date)}
                </span>
              </p>
            </div>

            {/* Blog content */}
            <div
              className="text-xl text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: blog.body
                  .replace(
                    /<ul>/g,
                    '<ul style="list-style-type: disc; margin-left: 1.5rem; margin-bottom: 1rem;">'
                  )
                  .replace(
                    /<ol>/g,
                    '<ol style="list-style-type: decimal; margin-left: 1.5rem; margin-bottom: 1rem;">'
                  )
                  .replace(/<li>/g, '<li style="margin-bottom: 0.5rem;">'),
              }}
            ></div>
          </article>
        )}
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default BlogDetailsAdmin;
